import { Component, HostListener, OnInit } from '@angular/core';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EventGPSResponse } from 'src/app/models/company.model';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  show = false;
  showMenu = false;
  user: any;
  company: any;
  templateSrc = "/images/company-avatar2.png";
  errorLoadImage = false;
  companyPopover = ``;
  events: EventGPSResponse[] = [];
  left = 0;
  showCompanyPopover = false;

  constructor(
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private toastService: ToastrService
  ) {
    this.user = JSON.parse(authService.getCurrentUser());
    this.company = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit() {
    this.companyPopover = `
                        <div class="popover-custom-v1">
                          <p class="alphanumeric-id">${this.company?.alphanumericId}</p>
                          <p class="company-name">${this.company?.companyName}</p>
                          <p class="company-nit">NIT: <b>${this.company?.companyNIT}</b></p>
                          <p class="link">
                            <a href='select-company' class="clickeable">
                            CAMBIAR<i class="fa-solid fa-circle-right"></i>
                            </a>
                          </p>
                        </div>
    `;
    this.left = 0;
    if (this.company){
      this.getEventsNearly();
      interval(60000*5).pipe(
        switchMap(() => this.companyService.getEventsNearly())
      ).subscribe(events => {
        this.events = events['data'];
        this.left = 0;
        this.events.forEach((eventGPS) => {
          if (!eventGPS.showed) {
            this.left++;
          }
        });
      });
    } 
  }

  getEventsNearly() {
    this.companyService.getEventsNearly().subscribe({
      next: (response: ResponseObject) => {
        this.events = response.data;
        this.events.forEach((eventGPS) => {
          if (!eventGPS.showed) {
            this.left++;
          }
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los días");
      }
    })
  }

  logout() {
    this.authService.logout();
  }

  saludar() {
    let tiempo = new Date();
    let hora, cad = "son las ";
    hora = tiempo.getHours();
    if (hora < 12)
      cad = "Buenos días ";
    else if (hora < 18)
      cad = "Buenas tardes ";
    else
      cad = "Buenas noches ";
    return cad
  }

  getIconForEvent(event: EventGPSResponse){
    if (event.application.newCompany.id != event.application.parentCompany.id) {
      return "fa-handshake";
    } else if (event.description.toLowerCase().includes("transferencia")){
      return "fa-hand-holding-hand";
    } else {
      return "fa-cash-register";
    }
  }

  getRediction(event: EventGPSResponse){
    if (event.application.newCompany.id != event.application.parentCompany.id) {
      return "#";
    } else if (event.description.toLowerCase().includes("transferencia")){
      return "/dashboard/transfer-cash-bank/"+event.eventId;
    } else if (event.description.toLowerCase().includes("información incompleta del producto")){
      return "#";
    } else {
      return "/dashboard/cash-and-accounts/"+event.eventId;
    }
  }

  toggleCompanyPopover() {
    this.showCompanyPopover = !this.showCompanyPopover;
  }

  closeCompanyPopover() {
    this.showCompanyPopover = false;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.container-company')) {
      this.showCompanyPopover = false;
    }
  }
}
